export default __webpack_public_path__ + "static/media/035-olives.ebee9ca6.svg";